export default "__VITE_ASSET__64717431__"